module.exports = __webpack_public_path__ + "static/media/date-picker-arrow-left.8de78b66.svg";